import {TypeMontant} from './TypeMontant';
export class TypeAutresInfosATTR {

	public nbParticipants: number;

	public dateAttribution: string;

	public valeurTotaleEstimee: TypeMontant;

	public nbOffresRecues: number;

	public primeAttribuee: TypeMontant;

	public informations: string;

	public nbParticipantsEtrangers: number;

	constructor() {
		 		this.nbParticipants = 0;
		this.dateAttribution = '';
		this.valeurTotaleEstimee = new TypeMontant();
		this.nbOffresRecues = 0;
		this.primeAttribuee = new TypeMontant();
		this.informations = '';
		this.nbParticipantsEtrangers = 0;

	}
}
